<template>
	<div
		class="flex w-full gap-4 rounded-lg border px-3 py-2 text-md leading-[22px]"
		:class="[isSuccess ? ' bg-won-green-light text-won-green' : ' bg-[#FFE3E0] text-won-red-dark']"
	>
		<div>
			<component
				:is="IconComponent"
				class="size-6"
			/>
		</div>
		<div class="font-medium">{{ message }}</div>
	</div>
</template>

<script setup>
import { HandThumbUpIcon, ExclamationCircleIcon } from '@heroicons/vue/24/solid';

const props = defineProps({
	isSuccess: {
		type: Boolean,
		default: true,
	},
	message: {
		type: String,
		default: '',
	}
});

const IconComponent = props.isSuccess ? HandThumbUpIcon : ExclamationCircleIcon;
</script>
